import { z } from "zod/v4";
import {
	bulkAddMembersResponseSchema,
	memberSuggestionSchema,
	removeGroupMemberResponseSchema,
	trainingGroupMemberSchema,
} from "../../schemas/training";
import { fetchApi, fetchVoid } from "../internal";

export const members = {
	add: (clubId: string, groupId: string, userId: string) =>
		fetchVoid(`/clubs/${clubId}/training/groups/${groupId}/members`, {
			body: JSON.stringify({ user_id: userId }),
			method: "POST",
		}),
	bulkAdd: (clubId: string, groupId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/training/groups/${groupId}/members`, bulkAddMembersResponseSchema, {
			body: JSON.stringify(data),
			method: "PUT",
		}),
	list: (clubId: string, groupId: string) =>
		fetchApi(
			`/clubs/${clubId}/training/groups/${groupId}/members`,
			z.array(trainingGroupMemberSchema),
		),
	promote: (clubId: string, groupId: string, userId: string) =>
		fetchVoid(`/clubs/${clubId}/training/groups/${groupId}/members/${userId}`, {
			method: "PATCH",
		}),
	remove: (clubId: string, groupId: string, userId: string) =>
		fetchApi(
			`/clubs/${clubId}/training/groups/${groupId}/members/${userId}`,
			removeGroupMemberResponseSchema,
			{ method: "DELETE" },
		),
	suggestions: (clubId: string, groupId: string, q?: string) => {
		const params = q ? `?q=${encodeURIComponent(q)}` : "";
		return fetchApi(
			`/clubs/${clubId}/training/groups/${groupId}/suggestions${params}`,
			z.array(memberSuggestionSchema),
		);
	},
};
